import React from "react";
import { BrowserRouter, Switch } from "react-router-dom";
import { ToastContainer } from "react-toastify";

import LoggedInLayout from "../layout";
import Dashboard from "../pages/Dashboard/";
import Tickets from "../pages/Tickets/";
import Signup from "../pages/Signup/";
import Login from "../pages/Login/";
import Connections from "../pages/Connections/";
import Settings from "../pages/Settings/";
import Users from "../pages/Users";
import Contacts from "../pages/Contacts/";
import QuickAnswers from "../pages/QuickAnswers/";
import Queues from "../pages/Queues/";
import Tags from "../pages/Tags/";
import Kanban from "../pages/Kanban/";
import Attendance from "../pages/Attendance/";
import FollowUps from "../pages/FollowUps/";
import TicketCustomFields from "../pages/TicketCustomFields/";
import AuditLogs from "../pages/AuditLogs/";
import AutomationRules from "../pages/AutomationRules/";
import InternalChat from "../pages/InternalChat/";
import { AuthProvider } from "../context/Auth/AuthContext";
import { WhatsAppsProvider } from "../context/WhatsApp/WhatsAppsContext";
import { ThemeProvider } from "../context/DarkMode";
import { VoiceRoomProvider } from "../context/VoiceRoom/VoiceRoomContext";
import Route from "./Route";

const Routes = () => {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ThemeProvider>
          <Switch>
            <Route exact path="/login" component={Login} />
            <Route exact path="/signup" component={Signup} />
            <WhatsAppsProvider>
              <VoiceRoomProvider>
                <LoggedInLayout>
                  <Route exact path="/" component={Dashboard} isPrivate />
                  <Route exact path="/tickets/:ticketId?" component={Tickets} isPrivate />
                  <Route exact path="/connections" component={Connections} isPrivate />
                  <Route exact path="/contacts" component={Contacts} isPrivate />
                  <Route exact path="/users" component={Users} isPrivate />
                  <Route exact path="/quickAnswers" component={QuickAnswers} isPrivate />
                  <Route exact path="/Settings" component={Settings} isPrivate />
                  <Route exact path="/Queues" component={Queues} isPrivate />
                  <Route exact path="/tags" component={Tags} isPrivate />
                  <Route exact path="/kanban" component={Kanban} isPrivate />
                  <Route exact path="/attendance" component={Attendance} isPrivate />
                  <Route exact path="/follow-ups" component={FollowUps} isPrivate />
                  <Route exact path="/ticket-custom-fields" component={TicketCustomFields} isPrivate />
                  <Route exact path="/audit-logs" component={AuditLogs} isPrivate />
                  <Route exact path="/automation-rules" component={AutomationRules} isPrivate />
                  <Route exact path="/internal-chat" component={InternalChat} isPrivate />
                </LoggedInLayout>
              </VoiceRoomProvider>
            </WhatsAppsProvider>
          </Switch>
          <ToastContainer autoClose={3000} />
        </ThemeProvider>
      </AuthProvider>
    </BrowserRouter>
  );
};

export default Routes;
